import(/* webpackMode: "eager" */ "c:\\projects\\front-next\\my-project\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "c:\\projects\\front-next\\my-project\\src\\app\\homepage\\components\\ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "c:\\projects\\front-next\\my-project\\src\\app\\homepage\\components\\HeroSlideshow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "c:\\projects\\front-next\\my-project\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager" */ "c:\\projects\\front-next\\my-project\\src\\components\\ui\\AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "c:\\projects\\front-next\\my-project\\src\\components\\ui\\AppImage.tsx");
